// src/layout/AuthLayout.tsx

import React from 'react';
import { Outlet } from '@tanstack/react-router';
import {Container, GradientCardLayout, Loader} from 'shared-portal-component';

import Footer from '@/components/molecules/Footer/Footer';
import { useGlobalLoader } from '@/hooks/useGlobalLoader';

const AuthLayout: React.FC = () => {
  const { show } = useGlobalLoader();

  return (
    <GradientCardLayout gradientClass="gradient-bg" footer={<Footer />} logo="/Logo.svg" title="">
      <Container fluid className='w-full'>
        <Outlet />
      </Container>
      {show && <Loader />}
    </GradientCardLayout>
  );
};

export default AuthLayout;
